import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["textarea"]

  toggleReply(event) {
    const commentId = event.currentTarget.dataset.commentId
    const replyForm = document.getElementById(`reply-form-${commentId}`)
    if (replyForm) {
      replyForm.classList.toggle("hidden")
      if (!replyForm.classList.contains("hidden")) {
        replyForm.querySelector("textarea")?.focus()
      }
    }
  }

  clearForm(event) {
    if (event.detail.success) {
      if (this.hasTextareaTarget) {
        this.textareaTarget.value = ""
      }
    }
  }

  afterReply(event) {
    if (event.detail.success) {
      const textarea = this.element.querySelector("textarea")
      if (textarea) textarea.value = ""
      this.element.classList.add("hidden")
    }
  }
}
